import React from "react";
import styled from "react-emotion";
import { Icon } from "antd";

const Container = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  border: "1px solid #e0e0e0",
  margin: "auto",
  div: {
    // margin: "0 8px",
    overflow: "hidden",
    img: {
      height: "36px",
      margin: "10px 2px",
      verticalAlign: "top",
      position: "relative"
    }
  }
});

const ImageWrapper = styled("div")({
  position: "relative"
});

const LastImage = styled("div")({
  alignItems: "center",
  backgroundColor: "rgba(0,0,0,.54)",
  bottom: 0,
  color: "#fff",
  display: "flex",
  height: "36px",
  width: "100%",
  justifyContent: "center",
  position: "absolute",
  margin: "10px 2px"
});

const Thumbnails = props => {
  const { selectedImages, onEditImages } = props;
  const images = selectedImages.slice(0, 6);
  return (
    <Container>
      {images.map((image, index) => {
        if (index === 5 && selectedImages.length > 6)
          return (
            <ImageWrapper>
              <img
                key={image.uid}
                src={image.url}
                alt="cropped"
                className="cropped-image"
              />
              <LastImage>
                <span>{selectedImages.length - images.length}</span>
              </LastImage>
            </ImageWrapper>
          );
        return (
          <ImageWrapper key={image.uid}>
            <img src={image.url} alt="cropped" className="cropped-image" />
          </ImageWrapper>
        );
      })}
      <Icon
        onClick={onEditImages}
        type="edit"
        title="Edit"
        style={{
          fontSize: "16px",
          margin: "20px 2px",
          verticalAlign: "top",
          cursor: "pointer"
        }}
      />
    </Container>
  );
};

export default Thumbnails;
